import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Label,
  Form,
  TextField,
  TextareaField,
  SelectField,
  RadioField,
  Button,
  PhoneArray,
  EmailArray,
  validation,
  filterErrors,
} from '../common';
import { genders } from '../../lib/lookups';

const validate = (values, setErrors) => {
  const errors = [];
  if (!values.first_name) {
    errors.push(['first_name', 'First name can\'t be empty']);
  }
  if (!values.last_name) {
    errors.push(['last_name', 'Last name can\'t be empty']);
  }

  if (!values.gender) {
    errors.push(['gender', 'Select a gender']);
  }
  if (!values.staff_type) {
    errors.push(['staff_type', 'Select a type']);
  }

  if (errors.length) {
    setErrors(errors.reduce((error, [field, message]) => {
      return {
        ...error,
        [field]: message,
      };
    }, {}));
    return false;
  }
  return true;
};

export default function EntityForm({ show, values: formValues, onClose, onSave, staffTypes }) {
  if (!show) {
    return null;
  }
  return (
    <Container
      onClose={onClose}
      style={{
        position: 'absolute',
        top: 60,
        right: 0,
        minHeight: 600,
        width: 500,
      }}
    >
      {Object.keys(formValues).length
        ? (
          <Label
            type="title"
          >Edit Staff Member {formValues.first_name} {formValues.last_name}</Label>
        )
        : (
          <Label
            type="title"
          >Add New Staff</Label>
        )}
      <Form
        values={formValues}
        validate={(touched, values) => {
          const errors = {};
          Object.keys(touched).forEach((field) => {
            if (field.startsWith('emails') && field.length > 6) {
              if (!validation.email(values.emails[field.substring(7, field.length - 1)])) {
                errors[field] = 'Invalid email';
              }
            }
            if (field.startsWith('phones') && field.length > 6) {
              if (!validation.phone(values.phones[field.substring(7, field.length - 1)])) {
                errors[field] = 'Invalid phone';
              }
            }

            if (field === 'first_name' && values.first_name === '') {
              errors.first_name = 'First name can\'t be empty';
            }
            if (field === 'last_name' && values.last_name === '') {
              errors.last_name = 'Last name can\'t be empty';
            }
            if (field === 'gender' && !values.gender) {
              errors.gender = 'Select a gender';
            }

            if (field === 'staff_type' && !values.staff_type) {
              errors.staff_type = 'Select a type';
            }
          });
          return errors;
        }}
      >{({ values, getHandler, onChange, errors, hasErrors, setErrors }) => {
        return (
          <div>
            <div>
              <SelectField
                style={{ width: '100%' }}
                value={values.staff_type}
                onChange={getHandler('staff_type')}
                label="Type"
                options={staffTypes}
                error={errors.staff_type}
              />
            </div>
            <div>
              <TextField
                style={{ width: '50%', paddingRight: 5 }}
                label="First Name"
                value={values.first_name || ''}
                onChange={getHandler('first_name')}
                error={errors.first_name}
              />
              <TextField
                style={{ width: '50%', paddingLeft: 5 }}
                label="Last Name"
                value={values.last_name || ''}
                onChange={getHandler('last_name')}
                error={errors.last_name}
              />
            </div>
            <div>
              <div
                style={{
                  display: 'inline-block',
                  verticalAlign: 'top',
                  width: '50%',
                  paddingRight: 5,
                }}
              >
                <PhoneArray
                  value={values.phones}
                  label="Phone"
                  errors={filterErrors('phones', errors)}
                  onChange={(touched, value) => {
                    onChange('phones', value, touched);
                  }}
                  widthSmall={120}
                  widthBig={145}
                />
              </div>
              <div
                style={{
                  display: 'inline-block',
                  verticalAlign: 'top',
                  width: '50%',
                  paddingLeft: 5,
                }}
              >
                <EmailArray
                  value={values.emails}
                  label="Email"
                  errors={filterErrors('emails', errors)}
                  onChange={(touched, value) => {
                    onChange('emails', value, touched);
                  }}
                />
              </div>
            </div>
            <div>
              <RadioField
                label="Gender"
                name="gender"
                onChange={getHandler('gender')}
                value={values.gender}
                options={genders}
                error={errors.gender}
              />
            </div>
            <div
              style={{
                marginTop: 20,
              }}
            >
              <TextareaField
                count
                max={160}
                style={{ width: '100%' }}
                label="Description"
                value={values.bio || ''}
                onChange={getHandler('bio')}
                error={errors.bio}
              />
            </div>
            <div>
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  if (!hasErrors && validate(values, setErrors)) {
                    onSave(values);
                    onClose();
                  }
                }}
                disabled={hasErrors}
                type="primary"
              >Save</Button>
            </div>
          </div>
        );
      }}</Form>
    </Container>
  );
}

EntityForm.propTypes = {
  show: PropTypes.bool.isRequired,
  values: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  staffTypes: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
};

EntityForm.defaultProps = {
  values: {},
  staffTypes: [],
};
